import React from 'react';
import {Alert, Button, Form, Modal, Spinner} from "react-bootstrap";
import {createNews} from "../../../api/News";

function NewsCreator() {
    const [modalShow, setModalShow] = React.useState(false);

    return (
        <>
            <Button variant="secondary" onClick={() => setModalShow(true)}>Créer une nouvelle news</Button>

            <FormularModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    );
}

function FormularModal(props) {
    const [title, setTitle] = React.useState("");
    const [text, setText] = React.useState("");
    const [type, setType] = React.useState("Sorties");
    const [date, setDate] = React.useState(new Date().toISOString());
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    async function handleSubmit() {
        const news = JSON.stringify({
            title: title,
            text: text,
            type: type,
            date: date,
            user: {
                id: 5
            }
        });

        setLoading(true)

        const newsCreated = await createNews(news);

        if (newsCreated.status === 201) {
            setLoading(false)
            window.location.href = "/news"
        } else if (newsCreated.status === 401) {
            setError('Il y a eut un problème lors de la création')
        }
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Création d'un événement
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formBasicEmail">
                        <Form.Label>Titre <b style={{color: 'red'}}>*</b></Form.Label>
                        <Form.Control type="text" placeholder="Entrer le titre" value={title} onChange={e => setTitle(e.target.value)} />
                        <Form.Text className="text-muted" style={{textAlign: 'right', marginRight: 5}}>
                            {title.length} / 100
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Informations <b style={{color: 'red'}}>*</b></Form.Label>
                        <Form.Control as="textarea" rows={3} value={text} onChange={e => setText(e.target.value)}/>
                        <Form.Text className="text-muted" style={{textAlign: 'right', marginRight: 5}}>
                            {text.length} / 2000
                        </Form.Text>
                    </Form.Group>

                    <Form.Group controlId="typeSelector">
                        <Form.Label>Type <b style={{color: 'red'}}>*</b></Form.Label>
                        <Form.Control as="select" onChange={e => setType(e.target.value)} value={type}>
                            <option disabled>------</option>
                            <option value="Sorties">Sorties</option>
                            <option value="Week-end">Week-end</option>
                            <option value="Autres">Autres</option>
                        </Form.Control>
                    </Form.Group>

                    {error !== null ? (
                        <Alert variant='danger'>
                            {error}
                        </Alert>
                    ) : null}
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>Close</Button>
                {loading ? (
                    <Spinner animation="grow" variant="primary" />
                ) : (
                    <Button variant="primary" onClick={handleSubmit}>Ajouter</Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

export default NewsCreator;
